<template>
<div class="phone">
  <div>
    <div v-html="phoneText"></div>
    <VuePhoneNumberInput
      default-country-code="US"
      v-model="phoneInput"
      @update="onUpdatePhone"
      no-validator-state
      />
  </div>
  <div class="buttons">
    <v-btn
      class="submit-button"
      color="primary"
      :disabled="!isValid"
      @click="onSubmit">
      {{ submitButton }}
    </v-btn>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

export default {
  name: 'Phone',
  components: {
    VuePhoneNumberInput,
  },
  computed: {
    ...mapState([
      'phoneText',
      'submitButton',
    ]),
  },
  data() {
    return {
      phoneInput: '',
      phoneNumber: '',
      isValid: false,
    };
  },
  methods: {
    onUpdatePhone(info) {
      this.isValid = info.isValid;
      this.phoneNumber = info.formattedNumber;
    },
    onSubmit() {
      this.$emit('phone', this.phoneNumber);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.phone {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;

  .buttons {
    display: flex;
    width: 100%;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-self: center;
    margin-top: 1rem;
  }
}

@media (min-width: $breakpoint-tablet) {
  .phone {
    justify-content: flex-start;

    .buttons {
      margin-top: 3rem;
    }
  }
}
</style>
